import React from 'react';
import { GBTypography } from '@leapfinance/geebee-component-library';
import { isFalsy } from '../../../../utils/common';
import CFCourseUtil from '../../../geebee/cf/CFCourseUtil';
var getUniversityLocation = function (state, city, country) {
    var address = '';
    if (state) {
        address += state;
    }
    if (!state && city) {
        address += city;
    }
    if (country) {
        address += ", ".concat(country);
    }
    return address;
};
var transformOpenIntakes = function (openIntakes) {
    var intakes = [];
    openIntakes === null || openIntakes === void 0 ? void 0 : openIntakes.forEach(function (intake) {
        intakes === null || intakes === void 0 ? void 0 : intakes.push("".concat(intake === null || intake === void 0 ? void 0 : intake.month, " ").concat(intake === null || intake === void 0 ? void 0 : intake.year));
    });
    return intakes === null || intakes === void 0 ? void 0 : intakes.join(', ');
};
export var courseInfoDetails = function (courseData) {
    if (!courseData || isFalsy(courseData))
        return [];
    var degreeName = courseData.degreeName, courseDurationInMonths = courseData.courseDurationInMonths, applicationFee = courseData.applicationFee, tuitionFee = courseData.tuitionFee, currencyCode = courseData.currencyCode, responseTimeInWeeks = courseData.responseTimeInWeeks, openIntakes = courseData.openIntakes, universityAddress = courseData.universityAddress, universityRank = courseData.universityRank;
    var _a = universityAddress || {}, city = _a.city, state = _a.state, country = _a.country;
    var _b = universityRank || {}, rank = _b.rank, rankingProviderName = _b.rankingProviderName;
    var courseInstance = new CFCourseUtil(courseData);
    return [
        (city || country || state) && {
            icon: React.createElement("i", { className: "fi fi-sr-marker" }),
            label: 'Institute Location',
            value: getUniversityLocation(state, city, country)
        },
        degreeName && {
            icon: React.createElement("i", { className: "fi fi-sr-marker" }),
            label: 'Degree',
            value: "".concat(degreeName !== null && degreeName !== void 0 ? degreeName : 'Postgraduate')
        },
        courseDurationInMonths && {
            icon: React.createElement("i", { className: "fi fi-sr-clock-five" }),
            label: 'Course Duration',
            value: "".concat(courseDurationInMonths, " Months")
        },
        !isFalsy(applicationFee) && {
            icon: React.createElement("i", { className: "fi fi-sr-usd-circle" }),
            label: 'Application Fee',
            value: applicationFee
                ? "".concat(courseInstance.convertInputToReadableCurrencyFormat(applicationFee, currencyCode !== null && currencyCode !== void 0 ? currencyCode : 'INR'))
                : 'No Fee'
        },
        !isFalsy(tuitionFee) && {
            icon: React.createElement("i", { className: "fi fi-sr-usd-circle" }),
            label: 'Tuition Fee',
            value: tuitionFee
                ? "".concat(courseInstance.convertInputToReadableCurrencyFormat(tuitionFee, currencyCode !== null && currencyCode !== void 0 ? currencyCode : 'INR'))
                : 'No Fee'
        },
        responseTimeInWeeks && {
            icon: React.createElement("i", { className: "fi fi-sr-clock-five" }),
            label: 'Response Time',
            value: "".concat(responseTimeInWeeks, " Weeks")
        },
        !isFalsy(openIntakes) && {
            icon: React.createElement("i", { className: "fi fi-sr-calendar" }),
            label: 'Open Intakes',
            value: transformOpenIntakes(openIntakes)
        },
        rank && {
            icon: React.createElement("i", { className: "fi fi-sr-ranking-star" }),
            label: 'Institute Rank',
            value: "#".concat(rank, " ").concat(rankingProviderName ? "by ".concat(rankingProviderName) : '')
        }
    ].filter(function (field) { return !!field; });
};
var CourseInfoSection = function (_a) {
    var _b;
    var courseData = _a.courseData;
    return (React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-y-4" }, (_b = courseInfoDetails(courseData)) === null || _b === void 0 ? void 0 : _b.map(function (courseInfo, index) {
        if (!courseInfo)
            return null;
        return (React.createElement("div", { key: index, className: "lfc-flex lfc-items-start lfc-gap-2" },
            React.createElement("div", { className: "lfc-mt-1" }, (courseInfo === null || courseInfo === void 0 ? void 0 : courseInfo.icon) ? courseInfo === null || courseInfo === void 0 ? void 0 : courseInfo.icon : null),
            React.createElement("div", { className: "lfc-flex lfc-flex-col" },
                React.createElement(GBTypography, { variant: "caption1", className: "lfc-text-grey-700" }, courseInfo === null || courseInfo === void 0 ? void 0 : courseInfo.label),
                React.createElement(GBTypography, { variant: "sh2Regular", className: "lfc-text-grey-800" }, courseInfo === null || courseInfo === void 0 ? void 0 : courseInfo.value))));
    })));
};
export default CourseInfoSection;
//# sourceMappingURL=CourseInfoSection.js.map